import styled, { keyframes } from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useTheme } from '../../ThemeProvider';

const DOT_COUNT = 3;
const DOT_SIZE = 4;
const ANIMATION_DURATION = 400;

interface CaptionLoaderProps {
  height: number;
}

export function CaptionLoader({ height }: CaptionLoaderProps) {
  const { textColor } = useTheme();

  return (
    <DotContainer
      $sx={{
        padding: `${(height - DOT_SIZE) / 2}px 0`
      }}
    >
      {Array.from({ length: DOT_COUNT }).map((_, index) => (
        <Dot
          key={index}
          $sx={{
            backgroundColor: textColor,
            animationDelay: `${1 + index * ANIMATION_DURATION}ms`
          }}
        />
      ))}
    </DotContainer>
  );
}

const DotContainer = styled.div.attrs({
  className: createReadableClass({
    component: 'radio-track-info',
    element: 'caption-loader-dot-container'
  })
})<WithSX>`
  ${applySX};
  display: flex;
  gap: 4px;
  min-height: ${DOT_SIZE}px;
`;

const activate = keyframes`
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
  `;

const Dot = styled.div.attrs<WithSX>({
  className: createReadableClass({
    component: 'radio-track-info',
    element: 'caption-loader-dot'
  })
})`
  opacity: 0.3;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  animation: ${activate} ${ANIMATION_DURATION * DOT_COUNT}ms infinite
    ease-in-out;
  ${applySX};
`;
